
  
// SEARCH POSITION SWITCH //  
  
function resize() {
    if ($(window).width() < 1024) {
      $('.nav-search').addClass('nav-search-section').removeClass('nav-search');
    }
    else {
      $('.nav-search-section').addClass('nav-search').removeClass('nav-search-section');
         }
    if ($(window).width() > 1024) {
      $('.mobile-search').addClass('browser-search').removeClass('mobile-search');
    }
    else {
      $('.browser-search').addClass('mobile-search').removeClass('browser-search');
         }
}

$(document).ready( function() {
    $(window).resize(resize);
    resize();
});



 // MOBILE SIDEBAR SWITCH //  
   
        function show() {
        $('#sidebar').toggleClass( "active" );
        $('body').scrollTop(400);
        $('#move-out').toggleClass( "active" );
        $('.mobile-nav').toggleClass( "active" );
        $('.menu-announcement-container').toggleClass( "active" );
        $('#move-search').removeClass( "active" );
        $('.mobile-search').removeClass( "active" );
        $('.mobile-suggestions').removeClass( "active" );
      } 
    
    
        function search() {
        $('body').scrollTop(400);
        $('#move-search').toggleClass( "active" );
        $('.mobile-search').toggleClass( "active" );
        $('.mobile-suggestions').toggleClass( "active" );
        $('.menu-announcement-container').toggle();
      }     


    



// BOOTSTRAP CAROUSEL SWIPE // 

$(".carousel").swipe({

  swipe: function(event, direction, distance, duration, fingerCount, fingerData) {

    if (direction == 'left') $(this).carousel('next');
    if (direction == 'right') $(this).carousel('prev');

  },
  allowPageScroll:"vertical"

});


    